export default {
  errorsRootKey: 'invoice/taxs',
  resource: 'invoice/taxs',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
